import { Injectable } from '@angular/core';
import maplibregl from 'maplibre-gl';

@Injectable()
export class StadiaMapsContextService {
  mapInstance: maplibregl.Map;
}
